import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserProfile {
  id: string;
  displayName: string;
  profileBio: string;
  joinDate: string;
  [key: string]: any;
}

interface UserProfileState {
  profile: UserProfile | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserProfileState = {
  profile: null,
  loading: false,
  error: null,
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserProfile | null>) => {
      state.profile = action.payload;
      state.loading = false;
      state.error = null;
    },
    setUserProfileLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUserProfileError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateUserProfileField: (
      state,
      action: PayloadAction<{ field: string; value: any }>
    ) => {
      if (state.profile) {
        state.profile[action.payload.field] = action.payload.value;
      }
    },
  },
});

export const {
  setUserProfile,
  setUserProfileLoading,
  setUserProfileError,
  updateUserProfileField,
} = userProfileSlice.actions;

export default userProfileSlice.reducer;